import { createContext, ReactNode, useContext } from 'react'
import { Brand } from '../../../server/src/user/user.contract'
import type { ResolvedEndUserTheme } from '../../../server/src/customer/end-user-theme.schema'

interface BrandContextType {
  brand: Brand
  // The customer's end-user theme; null only while the campaign is not loaded.
  endUserTheme: ResolvedEndUserTheme | null
}

const BrandContext = createContext<BrandContextType | undefined>(undefined)

export function BrandProvider({
  children,
  brand,
  endUserTheme = null,
}: {
  children: ReactNode
  brand: Brand
  endUserTheme?: ResolvedEndUserTheme | null
}) {
  return (
    <BrandContext.Provider value={{ brand, endUserTheme }}>
      {children}
    </BrandContext.Provider>
  )
}

export function useBrand(): BrandContextType {
  const context = useContext(BrandContext)
  if (context === undefined) {
    throw new Error('useBrand must be used within a BrandProvider')
  }
  return context
}
